import React, { useContext, useRef, useLayoutEffect } from "react";

export const Context = React.createContext();

const InitialRenderProvider = React.memo(({ children }) => {
  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
  });
  return (
    <Context.Provider value={{ isInitialRender: firstUpdate.current }}>
      {children}
    </Context.Provider>
  );
});

InitialRenderProvider.displayName = "InitialRenderProvider";
export const useInitialRender = () => {
  const { isInitialRender } = useContext(Context);
  return isInitialRender;
};

export default InitialRenderProvider;
